import axios from 'axios';

import { config } from '@/config/axios/config';
const { base_url, request_timeout } = config;

// 创建axios实例
const service = axios.create({
  baseURL: base_url, // api 的 base_url
  timeout: request_timeout, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  async (response) => {
    // console.log('response', response);
    const { data } = response;
    if (data.code == 310) {
      window.location.href = window.g.loginUrl;
    }
    return response;
  },
  (error) => {
    console.log('err' + error); // for debug
    return Promise.reject(error);
  }
);

export { service };
